import { Injectable } from '@angular/core';
import { ApiClass } from "@data/class/api-class";
import { IResponseArray } from "@data/interfaces/iresponseArray.interface";
import { environment } from "@env/environment";
import { catchError, map, of } from "rxjs";
import { IAdminList } from "@modules/private/admin/data/interfaces/iadmin.interface";
import { FilterOptions } from '@shared/interfaces/filterOptions.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiAdminService extends ApiClass {

  constructor() {
    super()
    this.path = 'users'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    this.path = 'users'
    const response: IAdminList = { error: true, msg: '', data: [], total: 0, status: 200, page: 1, itemsByPage: 10, totalItems: 0 }
    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters }).pipe(
      map((r) => r as IAdminList),
      catchError((e) => of(response))
    )
  }

  create(data: any) {
    // URL explícita (this.path es estado mutable compartido). Se envuelve la respuesta para que
    // el error del backend (4xx o 200-con-error) llegue por `next` como { error, msg, data }.
    return this.http.post(environment.apiUrl + 'users/create', data).pipe(
      map((r: any) => ({ error: r?.error ?? false, msg: r?.msg ?? '', data: r?.data ?? r })),
      catchError((e) => of({ error: true, msg: e?.error?.msg ?? 'Hubo un error de conexión', data: e?.error?.data ?? null }))
    )
  }

  update(id: string, data: any) {
    return this.putCollection(data, undefined, 'users/' + id).pipe(map((r) => r as { error: boolean, msg: string, data: any })).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  getRoles() {
    const filterOptions: FilterOptions = { page: 1, limit: 100, filters: {} }
    this.path = 'roles'
    
    return this.postCollection(filterOptions).pipe(
      map((response) => {
        if (!response.error && Array.isArray(response.data.data)) {
          return response.data.data.map((role: { _id: string, name: string }) => ({
            label: role.name,
            value: role._id
          }));
        } else {
          console.error('Error en la respuesta o los datos no son un array:', response.msg);
          return [];
        }
      }),
      catchError((error) => {
        console.error('Error al obtener los roles:', error);
        return [];
      })
    )
  }
}
